export const enum Placement {
    Left,
    Right,
}